document.addEventListener("DOMContentLoaded", () => {
  const arrow = document.querySelector(".js-arrow-down");

  if (arrow) {
    arrow.addEventListener("click", function () {
      let parentElement = this.closest("section");
      let nextSibling = parentElement.nextElementSibling;

      if (nextSibling) {
        const offset = 40;
        const elementPosition =
          nextSibling.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: elementPosition,
          behavior: "smooth",
        });
      }
    });
  }

  // window.onload = function () {
  //   setTimeout(() => {
  //     document.querySelector(".js-preloader").classList.add("preloader-hidden");
  //     setTimeout(() => {
  //       document.querySelector(".js-preloader").style.display = "none";
  //     }, 800);
  //   }, 500);
  // }
  
});
